import styled from 'styled-components'
import Grid from '@mui/material/Grid'

export const StyledAvatarInfo = styled(Grid)<{ $vertical?: boolean; size?: string; $loading?: boolean }>``

export const Content = styled.div``
